export default __webpack_public_path__ + "static/media/secimg.fbf68e26.png";